import { axios } from "@/plugins/http-request.js";

const state = {
  accessToken: null,
  expireOn: null,
  clientTypes: [],
  userTypes: [],
  activeCarriersListTypes: [],
};

const getters = {
  accessToken: (state) => state.accessToken,
  clientTypes: (state) => state.clientTypes,
  userTypes: (state) => state.userTypes,
  activeCarriersListTypes: (state) => state.activeCarriersListTypes,
};

const actions = {
  getDReports(context, payload) {
    return axios
      .get("/api/dashboard-report", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getDReportDetails(context, id) {
    return axios.get(`/api/dashboard-report/${id}`).then((res) => res.data);
  },
  createDReport(context, payload) {
    return axios
      .post("/api/dashboard-report-create", payload)
      .then((res) => res.data);
  },
  updateDReport(context, payload) {
    return axios
      .patch("/api/dashboard-report/" + payload.id, payload.data)
      .then((res) => res.data);
  },
  async generatePBIAtoken(context) {
    const currentTime = Date.now();
    if (
      context.state.accessToken &&
      +context.state.expireOn * 1000 - currentTime > 60000
    )
      return context.state.accessToken;
    const res = await axios.get(`api/powerbi/generate-access-token`);
    context.commit("setAccessToken", res.data.data.access_token);
    context.commit("setExpireOn", res.data.data.expires_on);
    return context.getters.accessToken;
  },
  async getClientTypes(context) {
    if (context.state.clientTypes.length) return;
    const res = await axios.get(`api/dashboard-report/clients`);
    context.commit("setClientTypes", res.data.data);
  },
  async getUserTypes(context) {
    if (context.state.userTypes.length) return;
    const res = await axios.get(`/api/dashboard/user-category`);
    context.commit("setUserTypes", res.data.data);
  },
  async getActiveCarriersListTypes(context) {
    if (context.state.activeCarriersListTypes.length) return;
    const res = await axios.get(`/api/carriers_list`);
    context.commit("setActiveCarriersListTypes", res.data.data);
  },

  getTypeClients(context, id) {
    if (id == undefined || id == "") {
      return axios.get(`/api/dashboard-report/clients`).then((res) => res.data);
    } else {
      return axios
        .get(`/api/dashboard-report/clients/${id}`)
        .then((res) => res.data);
    }
  },
  getRSAUserGroup(context, payload) {
    return axios
      .get(`/api/dashboard/user-group`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getRSAUserGroupdropdown(context, payload) {
    return axios
      .get(`/api/dashboard/user-group?flag=group_dropdown`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  async lastMileReport(context, payload) {
    return axios
      .post(`/api/export-report/last-mile`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  async shippingReport(context, payload) {
    return axios
      .post(`/api/export-report/shipping`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  async shippingFulfillmentReport(context, payload) {
    return axios
      .post(`/api/export-report/order-sku`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  ordersReport(context, payload) {
    return axios
      .post(`/api/export-report/orderlist`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  trackingReport(context, payload) {
    return axios
      .post(`/api/export-report/last-mile-tracking-details`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  b2bReport(context, payload) {
    return axios
      .post(`/api/export-report/b2b-sku-variants`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  inboundReport(context, payload) {
    return axios
      .post(`/api/export-report/b2b-inbound-download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  outboundReport(context, payload) {
    return axios
      .post(`/api/export-report/b2b-outbound-download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  putawayreport(context, payload) {
    return axios
      .post(`/api/export-report/inbound-putaway-transaction-report`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  preAlertReport(context, payload) {
    return axios
      .post(`/api/export-report/prealert-shipments`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  hawbReport(context, payload) {
    return axios
      .post(`/api/export-report/prealert-shipment-hawbs`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  async shippingStatus() {
    return axios
      .get(`/api/export-report/filters/shipping`)
      .then((res) => res.data);
  },
  async lastmileStatus() {
    return axios
      .get(`/api/export-report/filters/lastmile`)
      .then((res) => res.data);
  },
  async logList() {
    return axios
      .get(`/api/export-report/filters/outgoing_log`)
      .then((res) => res.data);
  },
  async getLogsData(context, payload) {
    return axios
      .post(
        `/api/outgoing/log-data?page=${payload.page}&itemsPerPage=${payload.itemsPerPage}&sortDesc=${payload.sortDesc}&mustSort=${payload.mustSort}&multiSort=${payload.multiSort}`,
        payload
      )
      .then((res) => res.data);
  },
  async slaReport(context, payload) {
    return axios
      .post(`/api/export-report/sla-tracker`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
};
const mutations = {
  setAccessToken(state, token) {
    state.accessToken = token;
  },
  setExpireOn(state, expireOn) {
    state.expireOn = expireOn;
  },
  setClientTypes(state, clientTypes) {
    state.clientTypes = clientTypes;
  },
  setUserTypes(state, userTypes) {
    state.userTypes = userTypes;
  },
  setActiveCarriersListTypes(state, activeCarriersListTypes) {
    state.activeCarriersListTypes = activeCarriersListTypes;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
